// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { BootstrapPagination } from '../../dsl/front';
import { isRelated } from '../../services';
import { AbstractModuleUi } from '../_abstract/ui';
/**
 * Component capable of rendering the `PaginationModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let PaginationModuleUi = class PaginationModuleUi extends AbstractModuleUi {
    constructor() {
        super(...arguments);
        /**
         * @see BootstrapPaginationProps.currentPage
         */
        this.currentPage = 1;
        /**
         * Description of the associated related list.
         */
        this.listDescription = null;
        /**
         * Page number's query param name.
         */
        this.pageParamName = 'page';
    }
    /**
     * @inheritDoc
     */
    async fetchRelated() {
        const { list } = this.module.content;
        if (!isRelated(list))
            return;
        try {
            this.listDescription = await this.relatedService.describe(list);
            this.onReady();
        }
        catch (e) {
            this.onError(e);
        }
    }
    /**
     * Handles the `@change` event on the `<BootstrapPagination>`.
     */
    onPageChange(page) {
        this.currentPage = page;
        this.$router.push({ query: { [this.pageParamName]: `${page}` } });
    }
    /**
     * @see BootstrapPaginationProps.showDirectionButtons
     */
    get showDirectionButtons() {
        return this.module.content.showDirectionButtons;
    }
    /**
     * @see BootstrapPaginationProps.totalPages
     */
    get totalPages() {
        if (this.listDescription === null || typeof this.listDescription.totalItems !== 'number') {
            return 0;
        }
        return Math.ceil(this.listDescription.totalItems / this.module.content.perPage);
    }
    /**
     * @see BootstrapPaginationProps.totalVisible
     */
    get totalVisible() {
        return this.module.content.totalVisible;
    }
    /**
     * Determines whether the `page` parameter exists in the URL query.
     */
    get hasPageInQuery() {
        return typeof this.pageFromQuery === 'string';
    }
    /**
     * `page` parameter from the URL query.
     */
    get pageFromQuery() {
        return this.$route.query[this.pageParamName];
    }
    /**
     * Reads the `page` param from the URL query and if it exists,
     * uses it as a starting point.
     */
    readPageFromQuery() {
        if (!this.hasPageInQuery) {
            return;
        }
        this.currentPage = parseInt(this.pageFromQuery);
    }
};
PaginationModuleUi = __decorate([
    Component({
        name: 'PaginationModuleUi',
        components: { BootstrapPagination },
        async created() {
            this.readPageFromQuery();
            await this.fetchRelated();
        },
        template: `
    <section class="pagination-module module"
             :class="[debugClass, loadingClass, versionClass]">
    <BootstrapPagination v-bind="{ currentPage, showDirectionButtons, totalPages, totalVisible }"
                         :link="{ target: $route, param: pageParamName }"
                         @change="onPageChange"/>
    </section>
  `
    })
], PaginationModuleUi);
export { PaginationModuleUi };
